var _excluded = ["image", "link", "label", "text"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { useContext } from "react";
import OnColorContext from "../../../contexts/OnColorContext";
import Picture from "../../quarks/Picture";
import { StyledLabelAtm, StyledImageWithTextLinkAtm } from "./ImageWithTextLinkAtm.styled";
function ImageWithTextLinkAtm(_ref) {
  var image = _ref.image,
    link = _ref.link,
    label = _ref.label,
    text = _ref.text,
    restProps = _objectWithoutProperties(_ref, _excluded);
  var onColor = useContext(OnColorContext);
  return /*#__PURE__*/React.createElement(StyledImageWithTextLinkAtm, _extends({
    $label: label,
    $onColor: onColor
  }, link, restProps), /*#__PURE__*/React.createElement(Picture, {
    srcData: image
  }), text, label ? /*#__PURE__*/React.createElement(StyledLabelAtm, {
    variant: label.variant,
    size: "small"
  }, label.text) : null);
}
export default ImageWithTextLinkAtm;